export const arkansasCountiesList = [
    'Arkansas',
    'Ashley',
    'Baxter',
    'Benton',
    'Boone',
    'Bradley',
    'Calhoun',
    'Carroll',
    'Chicot',
    'Clark',
    'Clay',
    'Cleburne',
    'Cleveland',
    'Columbia',
    'Conway',
    'Craighead',
    'Crawford',
    'Crittenden',
    'Cross',
    'Dallas',
    'Desha',
    'Drew',
    'Faulkner',
    'Franklin',
    'Fulton',
    'Garland',
    'Grant',
    'Greene',
    'Hempstead',
    'Hot Spring',
    'Howard',
    'Independence',
    'Izard',
    'Jackson',
    'Jefferson',
    'Johnson',
    'Lafayette',
    'Lawrence',
    'Lee',
    'Lincoln',
    'Little River',
    'Logan',
    'Lonoke',
    'Madison',
    'Marion',
    'Miller',
    'Mississippi',
    'Monroe',
    'Montgomery',
    'Nevada',
    'Newton',
    'Ouachita',
    'Perry',
    'Phillips',
    'Pike',
    'Poinsett',
    'Polk',
    'Pope',
    'Prairie',
    'Pulaski',
    'Randolph',
    'St. Francis',
    'Saline',
    'Scott',
    'Searcy',
    'Sebastian',
    'Sevier',
    'Sharp',
    'Stone',
    'Union',
    'Van Buren',
    'Washington',
    'White',
    'Woodruff',
    'Yell',
    ]